const createHistoryPushTab = (history: { push: (url: string) => void }, routeMatch: { url: string }) => (
  urlEnding: string
): void => {
  const urlStart = routeMatch.url.replace(new RegExp('/(\\d+)/.+?$'), '/$1');
  history.push(`${urlStart}/${urlEnding}`);
};

export { createHistoryPushTab };
